import axios from "../../api/axiosInstance";
import { readStoredAuthToken, readStoredUser } from "../../utils/sessionUser";
const cache = new Map(), waiting = [];
let running = 0, cacheScope = "", generation = 0;
export const productImageSession = () => { const user = readStoredUser(); return JSON.stringify([user?.id, user?.active_business_unit_id, user?.permissions, readStoredAuthToken()]); };
export function invalidateProductAssetUrls() { cache.clear(); generation++; }
export function queueProductImageRequest(fn, scope = productImageSession()) {
  return new Promise((resolve, reject) => {
    waiting.push({ fn, scope, resolve, reject }); drain();
  });
}
const finished = () => { running--; drain(); };
function drain() {
  while (running < 4 && waiting.length) {
    const task = waiting.shift(); running++;
    Promise.resolve().then(() => { if (task.scope !== productImageSession()) throw new Error("Image session changed"); return task.fn(); })
      .then(task.resolve, task.reject).finally(finished);
  }
}
const ordered = (value = {}) => Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)));
export function getProductAssetUrl(assetId, { context = {}, config, variant = "thumbnail", download = false, force = false } = {}) {
  const scope = productImageSession();
  if (cacheScope !== scope) { invalidateProductAssetUrls(); cacheScope = scope; }
  const params = { ...config?.params, ...context, variant, download };
  const key = JSON.stringify([scope, assetId, ordered(params), ordered(config?.headers), config?.pilcoreExpectedUserId]);
  if (force && cache.get(key)?.expiresAt !== Infinity) cache.delete(key);
  const existing = cache.get(key);
  if (existing && existing.expiresAt > Date.now()) return existing.promise;
  const epoch = generation, entry = { expiresAt: Infinity };
  entry.promise = queueProductImageRequest(async () => {
    const response = await axios.get(`/api/purchasing/product-assets/${assetId}/url`, { ...config, params });
    if (scope !== productImageSession() || epoch !== generation) throw new Error("Image session changed");
    if (typeof response.data?.url !== "string" || !response.data.url) throw new Error("Image unavailable");
    entry.expiresAt = Date.now() + Math.max(1000, Math.min(240000, ((Number(response.data.expires_in) || 300) - 30) * 1000));
    return { url: response.data.url, expiresAt: entry.expiresAt };
  }, scope).catch((error) => { if (cache.get(key) === entry) cache.delete(key); throw error; });
  cache.set(key, entry);
  while (cache.size > 300) cache.delete(cache.keys().next().value);
  return entry.promise;
}
